export default "__VITE_ASSET__223fd00d__"